export enum Type{
  feature = 'feature',
  resourceRate = 'resourceRate',
  resourcePercent = 'resourcePercent',
  resourceCount = 'resourceCount'
}